<template>
  <div class="app" v-title data-title="交通指南-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/jiaotong" class="f16 fw">交通指南</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
    </div>
    <div class="wz-jiaotong mt-40 pb100 w1200 auto">
      <div class="jt-box">
        <h2 class="f32 b">交通指南</h2>
        <!-- <div class="f18 mt15">公共交通：乘坐地铁9号线至松江大学城站下车，出站后转乘公交1801路至广富林路龙源站即可到达</div> -->
        <div class="f18 mt15" v-if="data && data.length > 0 && data[0].ContentText" v-html="data[0].ContentText"></div>
        <div class="c-flex">
          <div ref="gj" :class="{'active':isActive,'inactive':!isActive}" @click="toggleActive">公交</div>
          <div ref="zj" :class="{'active':isActive2,'inactive':!isActive2}" @click="toggleActive2">自驾</div>
          <div ref="qc" :class="{'active':isActive3,'inactive':!isActive3}" @click="toggleActive3">骑车</div>
          <div ref="bx" :class="{'active':isActive4,'inactive':!isActive4}" @click="toggleActive4">步行</div>
        </div>
        <div class="df align_center mt20">
          <div class="df align_center mr12">
            <div class="wz-jiaotong-icon df align_center justify_center">
              <img src="@/assets/images/wz-icon3.png" class="db" alt="" />
            </div>
            <!-- <el-select
              style="width: 490px;"
              v-model="value1"
              :multiple="false"
              filterable
              allow-create
              default-first-option
              placeholder="上海松江大学站">
              <el-option
                v-for="item in options"
                :key="item.value1"
                :label="item.label"
                :value="item.value1">
              </el-option>
            </el-select> -->
            <el-input v-model="startPlace" placeholder="请输入出发地" style="width: 490px;"></el-input>
          </div>
          <div class="df align_center mr12">
            <div class="wz-jiaotong-icon df align_center justify_center">
              <img src="@/assets/images/wz-icon4.png" class="db" alt="" />
            </div>
            <el-select
              style="width: 490px;"
              v-model="destPlace"
              :multiple="false"
              filterable
              clearable
              allow-create
              default-first-option
              placeholder="请选择目的地">
              <el-option
                v-for="(item, index) in preDestPlace"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div @click="queryRoutePlan">
            <img src="@/assets/images/wz-btn.png" class="db cp br5" height="40" alt="" />
          </div>
        </div>
        <div class="jiaotong-map mt15">
          <!-- <img src="@/assets/images/map-view.png" class="db wp100" alt="" /> -->
          <amap ref="amap" style="width: 1200px; height: 413px;"></amap>
        </div>
      </div>
      <div class="jiaotong-box mt40" style="margin-top: 450px;">
        <div class="jiaotong-tit df align_center">
          <div class="f20 b">停车</div>
        </div>
        <div class="jiaotong-text f18 tj mt10" v-if="data && data.length > 1 && data[1].ContentText" v-html="data[1].ContentText">
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30" v-if="data && data.length > 2 && data[2].ContentText">
          {{ data[2].Name }}
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20" v-if="data && data.length > 2 && data[2].ContentText" v-html="data[2].ContentText">
        </div>
        <!-- <div class="jiaotong-sub-tit f18 tj b mt30">
          湖底车库停车场
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20">
          <strong class="mr5">·</strong> 价格：10元/小时，30分钟内免费<br>
          <strong class="mr5">·</strong> 车位：485个<br>
          <strong class="mr5">·</strong> 地址：广富林文化遗址湖底车库车行<br>
        </div> -->
      </div>
      <div class="jiaotong-box mt40">
        <div class="jiaotong-tit df align_center">
          <div class="f20 b">公共交通</div>
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30" v-if="data && data.length > 3 && data[3].ContentText">
          {{ data[3].Name }}
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20" v-if="data && data.length > 3 && data[3].ContentText" v-html="data[3].ContentText">
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30" v-if="data && data.length > 4 && data[4].ContentText">
          {{ data[4].Name }}
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20" v-if="data && data.length > 4 && data[4].ContentText" v-html="data[4].ContentText">
        </div>
      </div>
      <!-- <div class="jiaotong-box mt40">
        <div class="jiaotong-tit df align_center">
          <div class="f20 b">公共交通</div>
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30">
          轨道交通
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20">
          <strong class="mr5">·</strong> 乘坐地铁9号线至“松江大学城站”下车，出站后转乘公交1801路至广富林路龙源站即可到达<br>
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30">
          公交车（广富林文化遗址朱雀门）
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20">
          <strong class="mr5">·</strong> 乘坐松江15路、24路、1801路以及99路到达“华东政法大学”站点下车往西200米。<br>
          <strong class="mr5">·</strong> 乘坐松江1801路以及95路到达“龙源路广富林路”站点下车，换乘松江99路至“华东政法大学”站点下车或者向广富林路步行800米。<br>
        </div>
      </div> -->
      <div class="jiaotong-box mt40">
        <div class="jiaotong-tit df align_center">
          <div class="f20 b">自驾线路</div>
        </div>
        <div class="jiaotong-text f18 tj mt10" v-if="data && data.length > 5 && data[5].ContentText" v-html="data[5].ContentText">
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30" v-if="data && data.length > 6 && data[6].ContentText">
          {{ data[6].Name }}
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20" v-if="data && data.length > 6 && data[6].ContentText" v-html="data[6].ContentText">
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30" v-if="data && data.length > 7 && data[7].ContentText">
          {{ data[7].Name }}
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20" v-if="data && data.length > 7 && data[7].ContentText" v-html="data[7].ContentText">
        </div>
      </div>
      <!-- <div class="jiaotong-box mt40">
        <div class="jiaotong-tit df align_center">
          <div class="f20 b">自驾线路</div>
        </div>
        <div class="jiaotong-text f18 tj mt10">
          <strong class="mr5">·</strong> 自驾车可以在百度导航内直接搜索广富林文化遗址湖底车库或者广富林郊野公园5号门，前往指定停车场。
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30">
          广富林文化遗址湖底车库车行入口
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20">
          <strong class="mr5">·</strong> 沿G60沪昆高速至嘉松南路新城收费站出口后，向北直行约4公里左转进入广富林路，行驶约2.6公里后右转进入龙源路，继续行驶约800米掉头到达。<br>
        </div>
        <div class="jiaotong-sub-tit f18 tj b mt30">
          广富林郊野公园5号门
        </div>
        <div class="jiaotong-text f18 tj mt10 lh20">
          <strong class="mr5">·</strong> 沿G60沪昆高速至嘉松南路新城收费站出口后，向北直行1.6公里左转进入新松江路。行驶4.6公里后右转进入辰塔路，继续行驶3公里到达<br>
        </div>
      </div> -->
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import amap from '@/components/AMapContainer.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value1: '',
        value2: '',
        startPlace: null,
        destPlace: null,
        code: 'app-wzfl-jtzn',
        data: null,
        preDestPlace: [],
        isActive:false,
        isActive2:false,
        isActive3:false,
        isActive4:false,
        jttype:1
       
    }
  },
  components: { Header, Bottom, amap},
  mounted() {
 
    this.loadData();
    this.isActive=true
  },
  methods:{
    queryRoutePlan() {
   
      this.$refs.amap.routePlan(this.startPlace, this.destPlace,this.jttype);
    },
     toggleActive() {
      this.isActive = !this.isActive; // 切换状态
       if(this.isActive===true)
       {  this.jttype=1
          this.isActive2=false
          this.isActive3=false
          this.isActive4=false
       }

     },
    toggleActive2() {
      this.isActive2 = !this.isActive2; // 切换状态
       if(this.isActive2===true)
       {
          this.jttype=2
          this.isActive=false
          this.isActive3=false
          this.isActive4=false
       }

     },
     toggleActive3(){
       this.isActive3=!this.isActive3;
       if(this.isActive3===true)
       {
          this.jttype=3
          this.isActive=false
          this.isActive2=false
          this.isActive4=false
       }

     },
      toggleActive4(){
       this.isActive4=!this.isActive4;
       if(this.isActive4===true)
       {
        this.jttype=4
          this.isActive=false
          this.isActive3=false
          this.isActive2=false
       }

     },
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data.Items;
          if(data.Items && data.Items.length > 8 && data.Items[8].Remark) {
            this.preDestPlace = this.data[8].Remark.split(",");
            this.destPlace = this.preDestPlace[0];
          }
        }
      })
    },
  },

}
</script>
<style scoped>
  .inactive
  {
     width: 60px;
     height: 30px; 
     font-size:15px; 
     background-color: #e9ebf1; 
     color:black;
     font-weight: 100; 
     text-align: center;
    border-width:0.01em;
    align-content: center;
    border-color: #ebe9e5;
    border-style:solid;
    cursor: pointer;
    
    
  }

  .active{
     
     width: 60px;
     height: 30px; 
     font-size:15px; 
     background-color: #4b360a; 
     border-color: #eee; 
     font-weight: 100; 
     text-align: center;
     color:#e9ebf1;
     border-width: 0.01em;
     align-content: center;

     border-style: solid;
     cursor: pointer;


  }

</style>



// WEBPACK FOOTER //
// src/views/wanzhuan/jiaotong.vue